import React, { Component } from 'react'
import ReportEndpoints from '../../../api/ReportEndpoints';
import Api from '../../../api/Api.js';
import DataTable from '../../../components/Table/DataTable';
import moment from 'moment';
import Loading from '../../../components/Loading/Loading';
import { store } from '../../../redux/store';
import { push } from 'connected-react-router';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Report Name",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class ArchiveHistory extends Component {
    options = {
        onRowClick: (row) => store.dispatch(push('/report/history/' + row[0]))
    };

    state = {
        loading: true,
        reports: []
    }

    componentDidMount() {
        Api.get(ReportEndpoints.withHistory).then(({ data }) => this.setState({ reports: data, loading: false })).catch((e) => console.error(e));
    }

    render() {

        if(this.state.loading) {
            return <Loading />
        }

        return (
            <DataTable
                title={"Archived Reports"}
                data={this.state.reports.map(rep => [rep.id, rep.name])}
                columns={columns}
                options={this.options}
                rowPointers
            />
        );
    }
}

export default ArchiveHistory